import { Home } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import * as React from "react";
import DrawerElement from "../molecules/drawer-element";

import MainLogo from "../molecules/main-logo";

export default function Header() {
  var [drawerOpen, setDrawerOpen] = React.useState(false);

  const pages = [
    { name: "Home", icon: Home, path: "/" },
    { name: "Kalender", path: "/calendar" },
    { name: "Kontakt", path: "/contact" },
  ];

  const mainTheme = useTheme();

  const toggleDrawer = (open) => (event) => {
    setDrawerOpen(open);
  };

  const DrawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Typography variant="h5" sx={{ paddingLeft: "10px" }}>
        Menu
      </Typography>

      {pages.map((page) => (
        <DrawerElement
          key={page.name}
          icon={page.icon}
          name={page.name}
          path={page.path}
        />
      ))}

      <Box sx={{ position: "absolute", bottom: "20px" }}>
        <DrawerElement icon="Impressum" name="Impressum" path="/impressum" />
      </Box>
    </Box>
  );

  return (
    <ThemeProvider theme={mainTheme}>
      <Box sx={{ flexGrow: 1 }}>
        <Drawer open={drawerOpen} onClose={toggleDrawer(false)}>
          {DrawerList}
        </Drawer>
        <AppBar
          width="100%"
          position="static"
          sx={{ backgroundColor: mainTheme.palette.background.paper }}
        >
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color={mainTheme.palette.secondary.main}
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            <MainLogo toggleDrawer={toggleDrawer} />
            <Box width="100%">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography
                  variant="h1"
                  color={mainTheme.palette.secondary.main}
                >
                  Schanzer Gemeinschaft Ingolstadt e.V.
                </Typography>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
    </ThemeProvider>
  );
}
